import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  isPlatform,
} from "@ionic/react";
import { useParams } from "react-router-dom";
import { DocumentCreateForm } from "./components/DocumentCreateForm";

export const DocumentCreate: React.FC = () => {
  console.log("DocumentCreate Render");

  const { userId }: { userId: string } = useParams();
  return (
    <IonPage>
      <IonHeader class="ion-no-border">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              text={isPlatform("ios") ? "Acuerdos" : ""}
              defaultHref={userId != undefined ? `/app/supervision/colaborador/${userId}` :"/app/rrhh/acuerdos"}
              color="light"
            />
          </IonButtons>
          <IonTitle>Nuevo Acuerdo</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <DocumentCreateForm />
      </IonContent>
    </IonPage>
  );
};
